import { render } from "./MaterialInputField.vue?vue&type=template&id=dc3373fa"
import script from "./MaterialInputField.vue?vue&type=script&lang=js"
export * from "./MaterialInputField.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__